<!-- eslint-disable no-return-assign -->
<!-- eslint-disable no-return-assign -->
<!-- eslint-disable no-return-assign -->
<!-- eslint-disable no-return-assign -->
<!-- eslint-disable no-return-assign -->
<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-title>Danh sách case</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field solo hide-details prepend-inner-icon="search" placeholder="Tìm trên danh sách này"
        v-model="keyword"></v-text-field>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table dense item-key="id" :headers="headers" :headers-length="20" :items="datasource"
      :rows-per-page-items="[10, 20, 50, 100]" :loading="isLoading" class="elevation-1">
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <v-btn color="primary" fab small dark @click="linkToCaseDeTail(props.item.id)">
              <v-icon>near_me</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.caseTypeName }}</td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.username }}</td>
          <td>{{ truncate(props.item.address) }}</td>
          <td class="no-wrap">{{ props.item.plate }}</td>
          <td>{{ props.item.imei }}</td>
          <td>
            <v-chip :color="getColorByCaseStatus(props.item.statusId)" dark small>
              {{ props.item.statusName }}
            </v-chip>
          </td>
          <td class="no-wrap">
            {{ formatGMTToLocalTime(props.item.requestTime) }}
          </td>
          <td class="no-wrap">
            {{ formatGMTToLocalTime(props.item.planTime) }}
          </td>
          <td>{{ truncate(props.item.worklog) }}</td>
          <td>{{ props.item.branch }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import validate from '@/utils/validate';
import { formatGMTToLocalTime } from '@/utils/datetime';
import axios from 'axios';

export default {
  // props: {
  //   name: String,
  //   datasource: Array,
  //   isLoading: Boolean
  // },
  // eslint-disable-next-line space-before-function-paren
  data() {
    return {
      headers: [
        {
          text: '',
          value: 'id',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Mã Case',
          value: 'code',
        },
        {
          text: 'Loại case',
          value: 'caseTypeName',
        },
        {
          text: 'Tiêu đề',
          value: 'title',
        },
        {
          text: 'Username',
          value: 'username',
        },
        {
          text: 'Địa chỉ',
          value: 'address',
        },
        {
          text: 'Biển số',
          value: 'plate',
        },
        {
          text: 'IMEI',
          value: 'imei',
        },
        {
          text: 'Trạng thái',
          value: 'statusName',
        },
        {
          text: 'TG KH YC',
          value: 'requestTime',
        },
        {
          text: 'TG Lắp',
          value: 'planTime',
        },
        {
          text: 'Ghi chú',
          value: 'worklog',
          width: '1%',
        },
        {
          text: 'Chi nhánh',
          value: 'branch',
        },
      ],
      isLoading: false,
      keyword: '',
      datasource: [],
    };
  },
  computed: {
    ...mapGetters(['searchText']),
  },
  watch: {
    // eslint-disable-next-line space-before-function-paren
    keyword() {
      this.getListCase();
    },
  },
  // eslint-disable-next-line space-before-function-paren
  created() {
    if (!this.searchText.startsWith('/')) {
      this.keyword = this.searchText;
    }
  },
  methods: {
    // eslint-disable-next-line space-before-function-paren
    truncate(text) {
      return text.substring(0, 30) + '...';
    },
    formatGMTToLocalTime,
    // eslint-disable-next-line space-before-function-paren
    search() {
      let keywordRemovedVietnamese = validate.transferVietnamese(
        this.keyword.toLowerCase()
      );
      this.datasource = this.datasource.filter((a) =>
        validate
          .transferVietnamese((a.plate || '').toLowerCase())
          .includes(keywordRemovedVietnamese.toLowerCase())
      );
    },
    // eslint-disable-next-line space-before-function-paren
    getListCase() {
      this.isLoading = true;
      if (this.keyword !== '') {
        let url = `https://sc-apiv2.vietmap.io/cases/support?SearchText=${this.keyword}`;
        console.log(url);
        this.axios.get(url).then((response) => {
          console.log(response.data);
          if (response.data.data.totalRecords > 0) {
            this.isLoading = false;
            let res = response.data.data.items;
            console.log('res', typeof res);
            this.datasource = res;
            this.datasource.forEach((item) => {
              switch (item.statusId) {
                case 1:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Mới');
                case 4:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Đang thực hiện');
                case 5:
                  // eslint-disable-next-line no-return-assign                  
                  return (item.statusName = 'Đã hoàn thành và đã đóng');
                case 6:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Chưa thực hiện');
                case 7:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Chờ xe');
                case 8:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Gia hạn');
                case 9:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Điều phối tự động');
                case 10:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Điều phối thất bại');
                case 2:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Đã hoàn thành');
                case 3:
                  // eslint-disable-next-line no-return-assign
                  return (item.statusName = 'Hẹn lại');
              }
            });
            console.log(this.datasource);
            return;
          }
          // eslint-disable-next-line no-lone-blocks
          {
            this.datasource = [];
            this.isLoading = false;
          }
        });
      } else {
        this.datasource = [];
        this.isLoading = false;
      }
    },
    // eslint-disable-next-line space-before-function-paren
    getColorByCaseStatus(statusId) {
      switch (statusId) {
        case 1:
          return 'red';
        case 2:
          return 'green';
        case 3:
          return 'purple';
        case 4:
          return 'orange';
        case 5:
          return 'grey darken-1';
        case 6:
          return 'blue';
        case 7:
          return 'pink';
        case 8:
          return 'steal';
        default:
          return 'black';
      }
    },
    // eslint-disable-next-line space-before-function-paren
    getItemPerPage(val) {
      console.log(val);
    },
    // eslint-disable-next-line space-before-function-paren
    linkToCaseDeTail(id) {
      window.open(
        `https://apps.vietmap.vn/#/redirect?appUrl=https://jet.vietmap.vn/public/eitn1cl8gkuaspqkojb7cv91hhl09evp;https://jet.vietmap.vn/app/vietmap/sc_admin/page/chi-tiet-case?ID=${id}`
      );
    },
  },
};
</script>

<style>
.no-wrap {
  white-space: nowrap;
}

.vue-iframe {
  height: 3000px !important;
}

.vue-iframe iframe {
  padding-top: -100px;
  width: 100%;
  margin-top: -55px;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/components/NewSC.vue